<template>
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th class="text-center">Valor R$</th>
        <th class="text-center">Vencimento</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(installment, key) in payment.range" :key="key">
        <td align="center">
          <strong>{{ key + 1 }}</strong>
        </td>
        <td>
          <InputMoney
            :id="key"
            v-model="installment.value"
            :precision="2"
            @input="updateValue"
            :onKeyup="changeRangeValue"
          />
        </td>
        <td>
          <InputDate
            :id="'paymentDate-' + key"
            aria-required="true"
            format="DD/MM/YYYY"
            :range="false"
            v-model="installment.date"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { InputDate, InputMoney } from '@/components/Form';
import { round } from 'lodash';
import FormatMixin from '../../modules/Application/mixins/FormatMixin';

export default {
  name: 'InstallmentTable',
  mixins: [FormatMixin],
  components: {
    InputMoney,
    InputDate,
  },
  props: ['payment'],
  data() {
    return {
      oldInstallmentValue: 0,
    };
  },
  computed: {
    ...mapState('purchase', ['payments']),
  },
  methods: {
    ...mapActions('purchase', ['setRemainder']),
    updateValue(_, oldValue) {
      this.oldInstallmentValue = this.valorUS(oldValue);
    },
    changeRangeValue(index) {
      const key = Number(index);
      const totalPaymentAmount = this.valorUS(this.payments.payment.value);
      const [installment] = this.payments.range.filter((_, idx) => idx === key);
      const currentInstallment = this.valorUS(installment.value) || 0.01;
      const lastIndex = this.payments.range.length - 1;

      if (currentInstallment >= totalPaymentAmount && key !== lastIndex) {
        this.payments.range[key].value = this.oldInstallmentValue;
        return;
      }

      const preCalculatedInstallments = this.payments.range.map((e, idx) => {
        if (this.valorUS(e.value) <= 0) e.value = currentInstallment;
        if (idx <= key) return e;

        const recalculatedInstallment =
          (totalPaymentAmount - currentInstallment) /
          (this.payments.range.length - (key + 1));

        return {
          ...e,
          value: recalculatedInstallment,
        };
      });

      const remainingAmount =
        this.calcTotalRange(preCalculatedInstallments) - totalPaymentAmount;
      if (!remainingAmount) {
        this.payments.range = preCalculatedInstallments;
        return;
      }

      const calculatedInstallments = preCalculatedInstallments.map((e, idx) => {
        if (idx <= key) return e;

        const recalculatedInstallment = round(
          (totalPaymentAmount - (currentInstallment + remainingAmount)) /
            (this.payments.range.length - (key + 1)),
          2,
        );

        return {
          ...e,
          value: recalculatedInstallment,
        };
      });

      if (this.calculatedInstallmentsExceedsTotal(calculatedInstallments)) {
        this.payments.range[key].value = this.oldInstallmentValue;
        return;
      }

      this.payments.range = calculatedInstallments;

      if (key !== lastIndex) {
        this.adjustDifference(totalPaymentAmount);
      }
    },
    calculatedInstallmentsExceedsTotal(calculatedInstallments) {
      return calculatedInstallments.some((i) => this.valorUS(i.value) < 0);
    },
    adjustDifference(totalPaymentAmount) {
      const diff = round(
        this.calcTotalRange(this.payments.range) - totalPaymentAmount,
        2,
      );
      const lastIndex = this.payments.range.length - 1;
      if (diff) this.payments.range[lastIndex].value -= diff;
    },
    calcTotalRange(range) {
      return range.reduce(
        (acc, obj) => round(acc + this.valorUS(obj.value), 2),
        0,
      );
    },
    setMinimumValue(e) {
      return {
        ...e,
        value: 0.01,
      };
    },
  },
};
</script>
